import { defineComponent, reactive, computed, watch } from 'vue';
import { useI18n } from 'vue-i18n';
import { ToggleInput, useMessageNotification } from '@hems/component';
import ApplianceControlPopup from '@hems/user/src/components/homeAppliance/ApplianceControlPopup.vue';
import { Helper } from '@hems/util';
export default defineComponent({
    name: 'ApplianceControlBox',
    components: {
        ToggleInput,
        ApplianceControlPopup,
    },
    props: {
        data: {
            type: Object,
            required: true,
        },
        applianceComponentType: {
            type: String,
            default: 'main',
        },
    },
    emits: ['save'],
    setup(props, { emit }) {
        const { t } = useI18n();
        const messageNotification = useMessageNotification();
        const state = reactive({
            isOn: props.applianceComponentType === 'main' ? props.data.isOn : props.data.indoor.isOn,
            controlPopup: {
                on: false,
                title: '',
                controlType: '',
            },
        });
        const applianceComponentTypeData = computed(() => props.applianceComponentType);
        const isShowMode = computed(() => getMode());
        const getMode = () => {
            switch (props.applianceComponentType) {
                case 'main':
                    return props.data.mode ?? false;
                case 'indoor':
                    return props.data.indoor.mode ?? false;
                default:
                    return false;
            }
        };
        const supportedModes = computed(() => props.applianceComponentType === 'main' ? props.data.supportedModes : props.data.indoor.supportedModes);
        const applianceControlBoxData = computed(() => props.data);
        watch(() => applianceControlBoxData.value, () => {
            state.isOn = props.applianceComponentType === 'main' ? props.data.isOn : props.data.indoor.isOn;
        });
        const checkOnOffline = async () => {
            if (applianceControlBoxData.value.isOnline)
                return true;
            await messageNotification
                .setMessageNotification('error', t('common.connection_error'), t('message.check_smartthings_connection'))
                .open();
            return false;
        };
        const onSave = (params, applianceItem) => {
            emit('save', params, applianceItem);
            state.controlPopup.on = false;
        };
        const onBeforeOnOff = async (value, beforeValue) => {
            const val = value ? 'On' : 'Off';
            const deviceType = props.data.profile_cd;
            if (applianceControlBoxData.value.isOnline) {
                const isOk = await messageNotification
                    .setMessageNotification('confirm', `Turn ${val} the device`, `Do you want to turn ${val} '${deviceType}'?`)
                    .open();
                if (isOk) {
                    const params = applianceComponentTypeData.value === 'main'
                        ? {
                            commands: [{ component: 'main', capability: 'switch', command: value ? 'on' : 'off' }],
                        }
                        : { commands: [{ component: 'INDOOR', capability: 'switch', command: value ? 'on' : 'off' }] };
                    if (!props.data) {
                        onSave(params, props.data);
                    }
                    return true;
                }
                if (typeof beforeValue === 'boolean') {
                    state.isOn = beforeValue;
                }
                return false;
            }
            await messageNotification
                .setMessageNotification('error', t('common.connection_error'), t('message.check_smartthings_connection'))
                .open();
            if (typeof beforeValue === 'boolean') {
                state.isOn = beforeValue;
            }
            return false;
        };
        const getApplianceControlBoxTemperatureData = () => {
            return applianceComponentTypeData.value === 'main'
                ? Helper.formatNumber(Number(applianceControlBoxData.value.setValue), 1)
                : Helper.formatNumber(Number(applianceControlBoxData.value.indoor.setValue), 1);
        };
        return {
            applianceControlBoxData,
            supportedModes,
            isShowMode,
            applianceComponentTypeData,
            state,
            onBeforeOnOff,
            checkOnOffline,
            onSave,
            getApplianceControlBoxTemperatureData,
        };
    },
});
